var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('b-table',{attrs:{"striped":"","small":"","stacked":_vm.is_mobile,"items":_vm.visible_rows,"fields":_vm.visible_fields}}),_c('b-button',{attrs:{"size":"sm","variant":"info"},on:{"click":function($event){return _vm.agreement()}}},[_vm._v(_vm._s(_vm.$t('agreement.agrements')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }